<div mat-dialog-content>
  <div class="layout-row justify-end">
    <button mat-dialog-close aria-label="close">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="#284154" xmlns="http://www.w3.org/2000/svg"><path d="M10.9394 12.0001L6.21968 16.7197L7.28034 17.7804L12 13.0607L16.7197 17.7804L17.7803 16.7197L13.0607 12.0001L17.7803 7.28039L16.7197 6.21973L12 10.9394L7.28034 6.21973L6.21968 7.28039L10.9394 12.0001Z"></path></svg>
    </button>
  </div>
  <gh-newsletter-form></gh-newsletter-form>
</div>
